export default __webpack_public_path__ + "static/media/CuciStep5.bfe7eab5.png";